import React, { FC } from 'react';
import { useHistory, useParams } from 'react-router';

import { REPORT_NOT_FOUND_STATE_KEY } from 'src/apps/mobile-common/consts/MobileCommonConsts';
import { MobileSdkSingleTestTabs } from 'src/apps/mobile-sdk/pages/single-test/MobileSdkSingleTestTabs';
import { MobileSdkSingleTestTabContent } from 'src/apps/mobile-sdk/pages/single-test/views/MobileSdkSingleTestTabContent';
import { RoutesHelper } from 'src/common/helpers/RoutesHelper';
import { useConfiguration } from 'src/common/providers/configurationProvider/ConfigurationProvider';
import { TableStateProvider } from 'src/common/providers/dashboard/TableStateProvider';
import { SessionViews } from 'src/common/types/WfaSessionViews';

import { MobileSdkSingleTestHeader } from './header/MobileSdkSingleTestHeader';

import './MobileSdkSingleTestPage.scss';

interface IMobileSdkSingleTestPageProps {
	viewId?: SessionViews;
}

export const MobileSdkSingleTestPage: FC<IMobileSdkSingleTestPageProps> = ({
	viewId = SessionViews.OVERVIEW
}) => {
	const history = useHistory();
	const { testId } = useParams<{ [key: string]: string }>();
	const { configuration } = useConfiguration();
	const showScansTab = configuration?.PLATFORM?.DEV_TOGGLES?.ENABLE_MOBILE_SCANS_VIEW ?? false;

	const onTestNotFoundCallback = (): void => {
		history.push(RoutesHelper.getMobileSdkDashboardPath(), {
			[REPORT_NOT_FOUND_STATE_KEY]: true
		});
	};

	return (
		<div className="mobile-sdk-single-test-page">
			<MobileSdkSingleTestHeader testId={testId} onTestNotFoundCallback={onTestNotFoundCallback} />
			<MobileSdkSingleTestTabs viewId={viewId} testId={testId} showScansTab={showScansTab} />
			<TableStateProvider>
				<MobileSdkSingleTestTabContent
					testId={testId}
					viewId={viewId}
					showScansTab={showScansTab}
				/>
			</TableStateProvider>
		</div>
	);
};
